export const getUserProfilePicUrl = (user) => {
  return user && user.profilePicUrl ?
    user.profilePicUrl :
    "https://s3.us-east-2.amazonaws.com/jaxitank-dev/image-placeholder-350x350.png";
}